<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      autocomplete="off"
      class="form-control"
      @change="changeOrganizationName"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <typeahead
      v-model="inputValue"
      :async-function="typeahead"
      :data="typeaheadData"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      :target="'#' + inputId"
      @input="selectTypeahead($event);savePreviousData($event) "
    >
      <template v-slot:item="props">
        <li
          v-for="(item, index) in props.items"
          v-bind:key="index"
          :class="{ active:props.activeIndex === index }"
        >
          <a role="button" @click="props.select(item)">
            <div v-html="props.highlight(item)"></div>
            <div>{{ item.inn }}</div>
            <div>{{ item.address }}</div>
          </a>
        </li>
      </template>
    </typeahead>
    <div
      v-if="visitor.personal.visitorOrganizationErr && visitor.personal.organization_name && visitor.personal.organization_inn"
      class="form-fielderror"
    >
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Наименование организации не должно совпадать с наименованием в секции "Заявитель"</div>
      </div>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
    <div v-if="showInnClue" class="visitor-organization-name-lower-clue">
      ИНН: {{ this.visitor.personal.organization_inn}}
    </div>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorOrganizationNameInput',

  components: { Hint },

  data: function () {
    return {
      previousOrgName: null,
      previousOrgInn: null
    }
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Наименование организации'
    },

    inputName: {
      default: 'organization_name'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId() {
      let inputId = `form-visitor-organization-name-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-organization`
      }

      return inputId
    },
    showInnClue() {
      return this.$emit('show-inn-clue', this.visitorIndex)
    }
  },

  methods: {
    changeOrganizationName() {
      this.visitor.personal.organization_inn = this.inputValue === this.previousOrgName ? this.previousOrgInn : null
    },

    savePreviousData(item) {
      if (item.inn) {
        this.previousOrgName = item.org_name
        this.previousOrgInn = item.inn
      }
    }
  }
}
</script>
